export default {
  list: {
    id: "Task ID",
    uid: "User ID",
    user: "User",
    userName: "User nickname",
    status: "Status",
    status_map: {
      1: "NOT CONTACTED",
      2: "invalid calls",
      3: "Contacted (not interested)",
      4: "Contacted (Interested)",
      5: "Contacted (hung up)",
    },
    platform: "TERRACE",
    platform_map: {
      0: "All",
      1: "ak777",
      2: "in11",
      3: "a11",
    },
    rechargeStatus: "Top-up status",
    rechargeStatus_map: {
      0: "All",
      1: "RECHARGED",
      2: "Not recharged",
    },
    mobile: "Mobile phone number",
    recordId: "PLATFORM-RECORD-ID",
    customerId: "CUSTOMER-ID",
    handleAt: "Processing time",
    notes: "NOTE",
    loginAt: "Landing time",
    rechargeAt: "Recharge time",
    assignedAt: "Allocate time",
    editStatus: "Edit the status",
    assignTasks: "Assign tasks",
    assignUser: "ASSIGNEES",
    tips: "Please select a task and reassign~",
    code: "Gift code",
    claimedAt: "Gift code claim time",
    mobileError: "Mobile phone number can only input numbers",
    giftAmount: "Gift amount",
  },
  config: {
    uid: "Employee ID",
    username: "Employee nickname",
    num: "The number of numbers assigned",
    todayCnt: "Number of assigned numbers",
    autoAssign: "Auto-allocation",
  },
};
